export default "__VITE_ASSET__$rTSGGVW__"